module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromReserve),
      expression: "fromReserve"
    }],
    domProps: {
      "value": (_vm.fromReserve)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromReserve = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toReserve),
      expression: "toReserve"
    }],
    domProps: {
      "value": (_vm.toReserve)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toReserve = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c5cd785!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/executive-dashboard/components/form/ReserveRange.vue
// module id = 1620
// module chunks = 0